import { useRef } from 'react';
import Loading from '@components/Loading/Loading';
type PropsType = {
  video: string;
  isPlaying: boolean;
  isLoading: boolean;
  loop: boolean;
  onPlay: () => void;
  onLoad: () => void;
  onEnded?: () => void;
  controls?: boolean;
  withSound?: boolean;
};
const YOUTUBE_ID_REGEX = /^[\w-]{11}$/;
const YOUTUBE_URL_REGEX = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
const getYouTubeVideoId = (url: string): string | null => {
  if (YOUTUBE_ID_REGEX.test(url)) {
    return url;
  }
  const match = url.match(YOUTUBE_URL_REGEX);
  return match && match[2].length === 11 ? match[2] : null;
};
const YouTubePlayer = ({
  video,
  isPlaying,
  isLoading,
  loop,
  onPlay,
  onLoad,
  controls = false,
  withSound = false
}: PropsType) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // watch / youtu.be nie da się osadzić w iframe (X-Frame-Options) — zawsze /embed/
  const videoId = getYouTubeVideoId(video);
  const baseUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : `https://www.youtube.com/embed/${video}`;

  // Parametry dla YouTube iframe
  const params = new URLSearchParams({
    autoplay: isPlaying ? '1' : '0',
    controls: controls ? '1' : '0',
    mute: withSound ? '0' : '1',
    loop: loop ? '1' : '0',
    playsinline: '1',
    rel: '0',
    showinfo: '0',
    modestbranding: '1'
  });

  // Dla loop dodajemy playlist z tym samym video ID
  if (loop && videoId) {
    params.append('playlist', videoId);
  }
  const iframeSrc = `${baseUrl}?${params.toString()}`;
  return <div style={{
    position: 'relative',
    width: '100%',
    height: '100%'
  }}>
      {isLoading && <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1
    }}>
          <Loading />
        </div>}

      {!isPlaying && !isLoading && <button type="button" onClick={onPlay} style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.5)',
      border: 'none',
      borderRadius: '50%',
      width: '80px',
      height: '80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 2
    }}>
          <div style={{
        width: 0,
        height: 0,
        borderLeft: '20px solid white',
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        marginLeft: '4px'
      }} />
        </button>}

      <iframe ref={iframeRef} src={iframeSrc} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen role="presentation" style={{
      width: '100%',
      height: '100%',
      border: 'none',
      display: isLoading ? 'none' : 'block'
    }} onLoad={onLoad} title="YouTube video player" />
    </div>;
};
export default YouTubePlayer;